import React from 'react'

const Home = () => {
  return (
    <div className='background' style={{height: '100vh', width: '100vw', overflow: 'hidden'}}>
        {/* <iframe
        src="https://www.oxfordscholastica.com/wp-content/uploads/2023/07/cambridge-college.jpg" // Replace with your desired URL
        title="External Website"
        style={{ border: 'none', height: '100vh', width: '100vw' }}
      ></iframe> */}
      <img src='https://www.oxfordscholastica.com/wp-content/uploads/2023/07/cambridge-college.jpg' alt='back-img' 
        style={{
            height: '100vh',
            width: '100vw',
        }}></img>
    </div>
  )
}

export default Home